import LocalizationManager from './LocalizationManager';
import { languages } from './localization';
import { locale as localeUtils } from '../utils/utils';

const { getShortLanguageCode } = localeUtils;

const getLocalizationManager = (locale: string) => {
    const shortLocale = getShortLanguageCode(locale) || 'en';
    const phrases = languages[shortLocale as keyof typeof languages];
    const localization = new LocalizationManager({
        locale,
        phrases: phrases || languages.en
    });

    return localization;
};

export { getLocalizationManager };
